import React, {Component} from 'react';
import Slider from 'react-slick'

class Pserviceslider extends Component{
    render(){
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0px',
            responsive: [
                {
                  breakpoint: 1250,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '0px',
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    centerPadding: '0px',
                  }
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    centerPadding: '0px',
                  }
                }
              ]
        };

        const images = [
          require('../../../img/resources/01.jpg'),
          require('../../../img/resources/02.jpg'),
          require('../../../img/resources/03.jpg'),
          require('../../../img/resources/04.jpg'),
          require('../../../img/resources/05.jpg'),
          require('../../../img/resources/06.jpg'),
          require('../../../img/resources/07.jpg'),
          require('../../../img/resources/08.jpg'),
          require('../../../img/resources/09.jpg'),
          require('../../../img/resources/10.jpg'),
          require('../../../img/resources/11.jpg'),
          require('../../../img/resources/12.jpg'),
          require('../../../img/resources/13.jpg'),
          require('../../../img/resources/14.jpg'),
        ]
        return(
            <Slider className="service_carousel" {...settings}>
              {images.map((x) => (
                <div className="service_item text-center">
                <img className="w-100" src={x} alt=""/>
                </div>
              ))}
                
            </Slider>
        )
    }
}
export default Pserviceslider;